module.exports = __webpack_public_path__ + "img/building_function.609818f7.png";